export const IS_PRODUCTION_ENV = process.env.REACT_APP_ENV === 'prod';
export const IS_QA_ENV = process.env.REACT_APP_ENV === 'qa';
